var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adspace container"},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-2292705730484150","data-ad-slot":"3103974598","data-ad-format":"auto","data-full-width-responsive":"true"}})])
}]

export { render, staticRenderFns }